//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseLayout from '@/layouts/base'
import { UsesAuthenticatedUser, UsesDashboardLinks } from '@/mixins'
import { find, findIndex } from 'lodash-es'
import { sync } from 'vuex-pathify'

export default {
  components: { BaseLayout },

  mixins: [
    UsesAuthenticatedUser,
    UsesDashboardLinks
  ],

  data () {
    return {
      activeSub: '',
    }
  },

  computed: {
    ...sync({
      activeDashboardTabIndex: 'myKintell/activeDashboardTabIndex'
    }),
    // Hacky way to hide the sub tabs when on a booking page
    hideSub () {
      const regex = /\/my-kintell\/bookings\/[^-]+(-[^-]+)+$/g // regex matches url for booking page
      return this.$route.path.match(regex) || this.$route.name === 'advisors-advisor-kintellCard-edit'
    },
    activeDashboardTab () {
      return this.dashboardLinks[this.activeDashboardTabIndex] || { sub: [] }
    },
    activeDashboardSubTab () {
      return find(this.activeDashboardTab.sub, sub => this.$route.path.includes(sub.link)) || {}
    }
  },

  watch: {
    $route: {
      handler () {
        this.updateActiveTab()
        this.maybeNavigateToFirstSub()
      },
      immediate: true
    }
  },

  mounted () {
    document.fonts && document.fonts.ready.then(() => this.$nextTick()).then(() => {
      if (this.$refs.tabs) {
        this.$refs.tabs.callSlider()
      }
    })
  },

  methods: {
    maybeNavigateToFirstSub () {
      if (this.activeDashboardTab.noTabs && this.activeDashboardTab.link === this.$route.path) {
        this.activeDashboardTab.sub[0] && this.$router.push(this.activeDashboardTab.sub[0].link)
      }
    },
    updateActiveTab () {
      const routeName = this.$route.name
      const path = this.$route.path
      // if it changes to a dashboard page
      if (path.includes('my-kintell')) {
        this.activeDashboardTabIndex = findIndex(this.dashboardLinks, e => path.includes(e.link))
        // update subtitle
        if (this.activeDashboardTab?.sub) {
          const sub = find(this.activeDashboardTab.sub, child => path.includes(child.link))

          if (sub) {
            this.activeSub = sub.link
          }
        }
      } else if (routeName === 'advisors-advisor-kintellCard-edit') {
        this.activeDashboardTabIndex = findIndex(this.dashboardLinks, e => e.link.includes('/my-kintell/kintell-cards'))
      } else {
        this.activeDashboardTabIndex = 0
      }
    },
  },
}
